import { useEffect } from "react";
export function useClickOutside(ref, onOutside, active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const onPointerDown = (event) => {
      const element = ref?.current;
      if (!element) return;
      if (element.contains(event.target)) return;
      onOutside?.();
    };
    window.addEventListener("mousedown", onPointerDown);
    return () => window.removeEventListener("mousedown", onPointerDown);
  }, [active, onOutside, ref]);
}